// extracted by mini-css-extract-plugin
module.exports = {"DataStore":"DataStore_ePnJy","DatastoreSkeleton":"DatastoreSkeleton_GDV6v","DataStoreTabs":"DataStoreTabs_vmKxb","DataStoreBackRow":"DataStoreBackRow_0YoJm"};